import { zonesReducer } from './zones.reducer'
export * from './zones.types'
export * from './zones.actions'
export * from './zones.thunks'

export default zonesReducer
